<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form">
                <div class="mcf-page-editor-header">
                    <label>Modifier les informations du produit</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <button @click="bt_save">
                        <i class="fa fa-save"></i>
                        <label>Enregistrer</label>
                    </button>
                    <button @click="bt_cancel">
                        <i class="fa fa-close"></i>
                        <label>Annuler</label>
                    </button>
                    <button style="position:absolute;right:10px;" @click="bt_delete">
                        <i class="fa fa-trash"></i>
                        <label>Supprimer</label>
                    </button>
                </div>
                <div class="mcf-page-editor-content">
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Informations générales</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Référence</label>
                            <input type="text" v-model="o.reference" placeholder="">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line">
                        <div class="mcf-page-editor-column-text">
                            <label>Description</label>
                            <textarea type="text" v-model="o.label" placeholder=""></textarea>
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2" v-if="o.line_type=='PRODUCT'">
                        <div class="mcf-page-editor-column-text">
                            <label>Quantité</label>
                            <input type="number" v-model="o.qty" placeholder="">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Prix de vente</label>
                            <input type="number" v-model="o.selling_price" placeholder="">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2" v-if="o.line_type=='PRODUCT'">
                        <div class="mcf-page-editor-column-choice">
                            <label>Remise</label>
                            <input type="number" v-model="o.discount_amount" placeholder="">
                            <span @click="o.discount_type='MONEY'" v-if="o.discount_type=='PERCENT'">%</span>
                            <span @click="o.discount_type='PERCENT'" v-if="o.discount_type=='MONEY'">€</span>
                        </div>
                    </div>
                    <div v-if="o.line_type=='PRODUCT'">
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Comptabilité</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Compte comptable</label>
                                <input type="text" v-model="o.account_number" placeholder="">
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-3">
                            <div class="mcf-page-editor-column-text">
                                <label>{{invoice.tax1_label}}</label>
                                <input @change="set_tax(1)" type="checkbox" v-model="o.is_tax1" id="istax1">
                                <label for="istax1"></label>
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>{{invoice.tax2_label}}</label>
                                <input @change="set_tax(2)" type="checkbox" v-model="o.is_tax2" id="istax2">
                                <label for="istax2"></label>
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>{{invoice.tax3_label}}</label>
                                <input @change="set_tax(3)" type="checkbox" v-model="o.is_tax3" id="istax3">
                                <label for="istax3"></label>
                            </div>
                        </div>       
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Informations complémentaires</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Famille</label>
                                <input type="text" v-model="o.family" placeholder="" list="lstfamilies" disabled>
                                <datalist id="lstfamilies">
                                    <option v-for="fam of invoice.lists.families" :key="fam.family" :value="fam.family">{{fam.family}}</option>
                                </datalist>
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Sous-famille</label>
                                <input type="text" v-model="o.subfamily" placeholder="" list="lstsubfamilies" disabled>
                                <datalist id="lstsubfamilies">
                                    <option v-for="sfam of invoice.lists.subfamilies" :key="sfam.subfamily" :value="sfam.subfamily">{{sfam.subfamily}}</option>
                                </datalist>
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Marque</label>
                                <input type="text" v-model="o.brand" placeholder="" list="lstbrands" disabled>
                                <datalist id="lstbrands">
                                    <option v-for="br of invoice.lists.brands" :key="br.brand" :value="br.brand">{{br.brand}}</option>
                                </datalist>
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Code à barre</label>
                                <input type="text" v-model="o.qrcode" placeholder="" disabled>
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Prix d'achat</label>
                                <input type="number" v-model="o.buying_price" placeholder="" disabled>
                            </div>
                        </div>
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Stock</label>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Gérer les stocks ?</label>
                                <input type="checkbox" v-model="o.is_qty_managed" id="isqtymanaged" disabled>
                                <label for="isqtymanaged"></label>
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Allée</label>
                                <input type="text" v-model="o.pathway" placeholder="" disabled>
                            </div>
                        </div>
                        <div class="mcf-page-editor-line-2">
                            <div class="mcf-page-editor-column-text">
                                <label>Travée</label>
                                <input type="text" v-model="o.bay" placeholder="" disabled>
                            </div>
                            <div class="mcf-page-editor-column-text">
                                <label>Casier</label>
                                <input type="text" v-model="o.rack" placeholder="" disabled>
                            </div>
                        </div>
                        <div class="mcf-page-editor-title">
                            <label><i class='fa fa-circle-info'></i> Commentaire</label>
                        </div>
                        <div class="mcf-page-editor-line">
                            <div class="mcf-page-editor-column-text">
                                <label>Commentaire</label>
                                <textarea type="text" v-model="o.note" placeholder="" disabled></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {DateTime} from "luxon";

export default {
    props:{
        account:Object,
        invoice:Object,
        line:Object,
        cancel:Function,
        save:Function
    },
    data(){
        return {
            o: this.line
        };
    },
    created() {
        this.o.is_qty_managed = (this.o.is_qty_managed==1);
        this.o.is_tax1 = (this.o.is_tax1==1);
        this.o.is_tax2 = (this.o.is_tax2==1);
        this.o.is_tax3 = (this.o.is_tax3==1);
    },
    methods:{
        set_tax: function(val){
            switch(val){
                case 1:
                    // this.prod.is_tax1 = !this.prod.is_tax1;
                    this.o.is_tax2 = false;
                    this.o.is_tax3 = false;                    
                    break;
                case 2:
                    this.o.is_tax1 = false;
                    // this.prod.is_tax2 = !this.prod.is_tax2;
                    this.o.is_tax3 = false;
                    break;
                case 3:
                    this.o.is_tax1 = false;
                    this.o.is_tax2 = false;
                    // this.prod.is_tax3 = !this.prod.is_tax3;
                    break;
            }
        },
        bt_cancel:function(){
            this.cancel();
        },
        bt_delete:function(){
            if (!isNaN(parseFloat(this.o.buying_price))==false){
                this.o.buying_price = 0;
            }
            if (!isNaN(parseFloat(this.o.selling_price))==false){
                this.o.selling_price = 0;
            }
            if (!isNaN(parseFloat(this.o.coef_margin))==false){
                this.o.coef_margin = 0;
            }
            this.o.is_deleted=1;
            this.save(this.o);
        },
        bt_save:function(){
            if (!isNaN(parseFloat(this.o.buying_price))==false){
                this.o.buying_price = 0;
            }
            if (!isNaN(parseFloat(this.o.selling_price))==false){
                this.o.selling_price = 0;
            }
            if (!isNaN(parseFloat(this.o.coef_margin))==false){
                this.o.coef_margin = 0;
            }
            this.save(this.o);
        }
    }
}
</script>